import { formatDate } from "../../helpers/date_helpers";

export function deploymentStatusLabel(device) {
    return device?.deployment_status?.name
}

export function deviceTypeLabel(device) {
    return device?.device?.device_type?.name || device?.part?.part_type?.name
}

export function updatedAtLabel(device) {
    // This must match the the format used in label_reducer_function.js'
    const date = new Date(device?.updated_at * 1000);
    return formatDate(date)
}

/**
 * The device cost chart aggregates cost by deployment status
 *
 * @param device
 * @returns {*}
 */
export function deviceCostLabel(device) {
    return deploymentStatusLabel(device);
}